// Import uniwersalnego wrappera do żądań HTTP
import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Serwis obsługujący białą listę tablic rejestracyjnych
class WhiteListsService {
  // Dodaje nową tablicę rejestracyjną do białej listy
  async postNewPlate(licensePlate, description, userId) {
    // Walidacja - nie dodawaj pustych tablic/opisu
    if (!licensePlate || !description) {
      return;
    }

    // Wyślij POST do API - typ listy 1 = biała lista
    const response = await fetchWrapper.post(
      process.env.VUE_APP_API_URL + '/wanted-plates',
      {
        plateLpr: licensePlate,
        typeOfList: 1,             // 1 = biała, 0 = czarna
        description: description,
        userId: userId
      }
    );
    return response;
  }

  // Pobierz użytkowników (do przypisywania pojazdów)
  async getUsers() {
    // Zwraca do 1000 użytkowników
    return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/users?page=1&limit=1000`);
  }
  
  // Pobierz WSZYSTKIE wpisy z białej listy (paginacja: pierwsza strona, 10 wyników)
  async getAll() {
    try {
      // Przygotuj parametry do zapytania (typesOfLists: [1] = biała lista)
      const params = new URLSearchParams({
        typesOfLists: [1],
        orderDirection: 'desc',
        page: 1,
        limit: 10
      });

      // Pobierz listę pojazdów na białej liście
      const response = await fetchWrapper.get(
        `${process.env.VUE_APP_API_URL}/wanted-plates?${params.toString()}`
      );

      return response;
    } catch (error) {
      console.error('Error fetching vehicles:', error);
    }
  }

  // Usuń pojazd z białej listy po ID
  async delete(id) {
    try {
      const response = await fetchWrapper.delete(
        `${process.env.VUE_APP_API_URL}/wanted-plates/${id}`
      );
      return response;
    } catch (error) {
      console.error('Error deleting vehicle:', error);
    }
  }
}

// Eksportuj singleton serwisu (wszędzie ta sama instancja)
export default new WhiteListsService();
